export default __webpack_public_path__ + "static/media/card-notifications.cd32d0f8.png";